import { TermService, SearchCollectionTagDto } from '@/api';
import callWithContext from '@/api/call-with-context';
import { ToolDefinition } from '../types';

const searchTermsTool: ToolDefinition = {
  name: 'search_terms',
  description: 'Search glossary terms. Use for business glossary, term definitions, or finding terms by name. Returns paginated results (totalElements). Fields: id, name, description, assetCount. Use textSearch to find by name/description.',
  input_schema: {
    type: 'object',
    properties: {
      textSearch: {
        type: 'string',
        description: 'Match text in term name/description',
      },
      page: {
        type: 'integer',
        description: 'Page number (default: 0)',
      },
      itemsPerPage: {
        type: 'integer',
        description: 'Items per page (default: 25)',
      },
      sort: {
        type: 'array',
        description: 'Sort: ["property,ASC"] or ["property,DESC"]. Example: ["name,ASC"]',
        items: {
          type: 'string',
        },
      },
    },
    required: [],
  },
};

/**
 * Execute the search_terms tool
 */
export async function executeSearchTerms(params: any): Promise<SearchCollectionTagDto | { error: string }> {
  try {
    let page = 1; // Default to 1 so interceptor makes it 0
    if (typeof params.page === 'number' && params.page >= 0) {
      page = params.page + 1; // Add 1 because interceptor will subtract 1
    }

    const requestParams: any = {
      page,
      itemsPerPage: params.itemsPerPage || 25,
    };

    if (params.textSearch) {
      requestParams.textSearch = params.textSearch;
    }

    if (params.sort) {
      requestParams.sort = params.sort;
    }

    const result = await callWithContext('sifflet-ai-chat', () => TermService.getAllTerm(requestParams));

    return result;
  } catch (error) {
    return { error: (error as Error).message };
  }
}

export default searchTermsTool;
